import { req } from '../../@api/request';

export default class BoardService {
  static articlList = async (
    //type: string,
    category: string | undefined,
    //search: string,
    limit: number,
    offset: number,
  ) => {
    const result = await req.get(
      `/notice?category=${category}&limit=${limit}&offset=${offset}`,
      //`/board/article/list?type=${type}&category=${category}&search=${search}&limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };
  static detail = async (articleIdx: number) => {
    const result = await req.get(`/notice/${articleIdx}`);
    return result.data;
  };
  static write = async (data: any) => {
    const result = await req.post(`/board/article`, data);
    return result.data;
  };
  static delete = async (articleIdx: number) => {
    const result = await req.delete(`/board/article/${articleIdx}`);
    return result.data;
  };
  static edit = async (articleIdx: number, data: any) => {
    const result = await req.patch(`/board/article/${articleIdx}`, data);
    return result.data;
  };
  static commentList = async (
    articleIdx: number,
    limit: number,
    offset: number,
  ) => {
    const result = await req.get(
      `/board/article/comment/${articleIdx}?limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };
  static commentWrite = async (articleIdx: number, data: any) => {
    const result = await req.post(`/board/article/comment/${articleIdx}`, data);
    return result.data;
  };
  static commentDelete = async (commentIdx: number) => {
    const result = await req.delete(`/board/article/comment/${commentIdx}`);
    return result.data;
  };
}
